import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { LoanType } from '@qred/shared-enums';
import useTranslate from '../useTranslate';
import { MARKETS_WITH_EXTERNAL_LOAN_TERMS_LINKS } from '~/constants/markets';
import useOpenLink from './useOpenLink';

const useLoanLinks = (loanType: LoanType) => {
  const openExternalLink = useOpenLink();
  const t = useTranslate();
  const {
    intl: { market },
  } = useSelector((state: RootState) => state);

  const hasExternalTermsLinks = MARKETS_WITH_EXTERNAL_LOAN_TERMS_LINKS.includes(
    market
  );
  const isAnnuityLoan = loanType === LoanType.ANNUITY_LOAN;

  const openGeneralTerms = () => {
    openExternalLink('LinkUrls.GeneralTerms', 'MissingLoanGeneralTermsUrl');
  };

  const openProductTerms = () => {
    const urlKey = isAnnuityLoan
      ? 'LinkUrls.InvestmentLoanTerms'
      : 'LinkUrls.FlexLoanTerms';
    openExternalLink(urlKey, 'MissingProductTermsUrl');
  };

  const openPriceList = () => {
    openExternalLink('LinkUrls.LoanPriceList', 'MissingLoanPriceListUrl');
  };

  const productTermsLinkText = isAnnuityLoan
    ? (t('OnboardingOffer.ProductTermsInvestmentLoanLinkText') as string)
    : (t('OnboardingOffer.ProductTermsFlexLoanLinkText') as string);

  return {
    hasExternalTermsLinks,
    openGeneralTerms,
    openProductTerms,
    openPriceList,
    productTermsLinkText,
  };
};

export default useLoanLinks;
